import React from "react";
import { FormikProps } from "formik";
import HorizontalPanel from "../HorizontalPanel";
import ExportSettingsForm from "../../containers/SettingsPage/ExportSettings/ExportSettingsForm";
import MultiChips from "../MiltiChips";
import { Grid } from "@material-ui/core";
import { ReportingFieldList } from "../ReportingDialog/reportingFieldList";
import { Toolbar } from "../../app/components";

import classes from './index.module.scss';

interface FormikInterface {
  fieldList: string[],
  exportDefaultUnits: string,
  exportEnumerationDivider: string,
  exportFieldDivider: string,
  exportDecimalDivider: string,
  exportDecimalPlaceDigits: number,
  exportFormatDate: string,
}

const ReportSettings = (props: { settingsFormik: FormikProps<FormikInterface> }) => {
  const { settingsFormik } = props;
  const allFields = ReportingFieldList.map((field) => {
    return {
      id: field,
      name: field,
    }
  })

  const selectedFields = settingsFormik.values.fieldList.map((field) => {
    return {
      id: field,
      name: field,
    }
  });

  return (
    <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE} className={classes.form}>
      <Toolbar title="Fields in report" />
      <Grid item xs={12}>
        <MultiChips
          name='fieldsList'
          items={allFields}
          selectedItems={selectedFields}
          onChange={
            (values: string[]) =>

              settingsFormik.setFieldValue(
                'fieldList',
                values)

          }
          helperText={settingsFormik.errors.fieldList}
          error={Boolean(settingsFormik.errors.fieldList)}
        />
      </Grid>
      <Toolbar title="Report settings" />
      <ExportSettingsForm settingsFormik={settingsFormik} />
    </HorizontalPanel>
  );
}

export default ReportSettings;